import { baseURL } from '@susu/headless-commerce/config/config'
import type { Locale } from '@susu/headless-commerce/config/locale'
import type { ProductsCart } from '@susu/headless-commerce/libs/avo/avo'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import type { PageType } from '@susu/headless-commerce/types/PageType'
import {
  pageLoaded,
  trackEvent,
} from '@susu/headless-commerce/utils/tracking/tracking'
import { getLocationIdValue } from './getURLTrackingValue'
import { configuratorURLData } from './trackingURL'

export const trackPageLoadedEvent = async ({
  categoryStep,
  country,
  locale,
  pageType,
  segmentProducts,
}: {
  categoryStep: string
  country: CountryConfiguration
  locale: Locale
  pageType: PageType
  segmentProducts: Array<ProductsCart>
}) => {
  const { path } = configuratorURLData(categoryStep)

  await trackEvent({
    ga: {
      eventCategory: 'Page_Loaded',
      eventAction: 'global_interactions',
      eventLabel: path,
    },
  })

  await pageLoaded({
    enrichProps: {
      country,
      locale,
    },
    properties: {
      customDestinationPageName_: pageType,
      locationId: getLocationIdValue(new URL(baseURL()), categoryStep),
      pageType: pageType,
      productsCart: segmentProducts,
    },
  })
}
